import React, { useContext } from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Card from '@material-ui/core/Card';
import useIntl from '@afosto/utils-react/intl/useIntl';
import translations from './translations';
import HandlingListContext from '../../../../components/HandlingListContext';
import Property from '@afosto/app-components-react/Property';
import formatDateTime from '@afosto/utils/date/formatDateTime';
import MuiLink from '@material-ui/core/Link';
import { Link } from 'react-router-dom';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';

const HandlingListInfoSection = () => {
  const intl = useIntl();
  const { handlingList = {}, location, isFetchingLocation } = useContext(HandlingListContext);

  return (
    <Card style={{ height: '100%' }}>
      <LoadingWrapper isLoading={isFetchingLocation}>
        <CardHeader
          title={intl.formatMessage(translations.title)}
          titleTypographyProps={{ variant: 'h6' }}
        />
        <CardContent>
          <Property
            label={intl.formatMessage(translations.properties.location)}
            value={
              location?.name && (
                <MuiLink to={`${location?.id}`} component={Link}>
                  {location?.name}
                </MuiLink>
              )
            }
          />
          <Property
            label={intl.formatMessage(translations.properties.startedAt)}
            value={handlingList?.started_at && formatDateTime(handlingList.started_at)}
          />
          <Property
            label={intl.formatMessage(translations.properties.finishedAt)}
            value={handlingList?.finished_at && formatDateTime(handlingList.finished_at)}
          />
          <Property
            label={intl.formatMessage(translations.properties.createdAt)}
            value={handlingList?.created_at && formatDateTime(handlingList.created_at)}
          />
          <Property
            label={intl.formatMessage(translations.properties.updatedAt)}
            value={handlingList?.updated_at && formatDateTime(handlingList.updated_at)}
          />
          <Property
            label={intl.formatMessage(translations.properties.dueAt)}
            value={handlingList?.due_at && formatDateTime(handlingList.due_at)}
          />
        </CardContent>
      </LoadingWrapper>
    </Card>
  );
};

export default HandlingListInfoSection;
